export default __webpack_public_path__ + "static/media/portada.0b56b8cd.webp";